module.exports = __webpack_public_path__ + "img/DSC00532-cropped-mobile.10bea8d5.webp";